import { ArrowRightIcon } from 'lucide-preact';
import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

import { useProductCard } from './context';

interface ProductCardWhatsIncludedTriggerProps extends Omit<ComponentProps<'button'>, 'onClick'> {
  /** Fired when the panel opens, and only then — going back is not a second open. */
  onOpen?: () => void;
}

/**
 * The row that opens the panel. Label centred with the arrow against the right edge, per the
 * designs, rather than the two sitting together in the middle.
 */
const ProductCardWhatsIncludedTrigger = ({
  className,
  children = "What's included?",
  onOpen,
  ...props
}: ProductCardWhatsIncludedTriggerProps) => {
  const { setShowWhatsIncluded } = useProductCard();
  return (
    <button
      type="button"
      className={cn(
        'preflight preflight-button relative flex w-full items-center justify-center text-sm leading-5 text-stone-500',
        className,
      )}
      onClick={() => {
        setShowWhatsIncluded(true);
        onOpen?.();
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <span>{children}</span>
      <ArrowRightIcon className="absolute right-0 size-4" />
    </button>
  );
};

export default ProductCardWhatsIncludedTrigger;
